let handler = () => { };
export const registerMaintenanceHandler = (fn) => {
    handler = fn;
};
export const setMaintenanceMode = (value) => {
    handler(value);
};
